import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'Components/Icon';
import { classnames } from 'Utils/classnames';

const PageAccordionRow = props => {
  const { subject, showNewLabel, onClick } = props;

  return (
    <div  className={ classnames({
      'page-accordion-row': true,
      'page-accordion-row--new': showNewLabel
    }) } onClick={ onClick } >
      <span className="page-accordion-row__subject">{ subject }</span>
      <Icon className="page-accordion-row__arrow" iconName="svgArrowRight" />
    </div>
  );
};

PageAccordionRow.propTypes = {
  subject: PropTypes.string,
  onClick: PropTypes.func,
  showNewLabel: PropTypes.bool
};

PageAccordionRow.defaultProps = {
  showNewLabel: false
};

export default PageAccordionRow;